// Import react elements
import { useState, useRef, useEffect } from 'react';

// Import css
import styles from 'global/components/CustomDropdownInput.module.css';



// Component that creates a dropdown selector which also allows custom text input (like html 'select' but better)
const CustomDropdownInput = ({ label, value, setValue, options = [], placeholder }) => {

    // Local state to control visibility of the dropdown options
    const [isOpen, setIsOpen] = useState(false);

    // Ref to track clicks outside the component
    const wrapperRef = useRef(null);



    // Open/close dropdown on input click
    const handleInputClick = () => {

        // Check if the dropdown is open
        if (isOpen) {

            // It is so close it
            setIsOpen(false);

        } else {

            // It isn't so show it
            setIsOpen(true);

        }

    };



    // Handle clicking a dropdown item
    const handleOptionClick = (option) => {

        // Set the value to the option clicked on
        setValue(option);

        // Close the dropdown
        setIsOpen(false);

    };



    // Close dropdown when clicking outside
    const handleOutsideClick = (e) => {

        // Check if the click event is not the dropdown
        if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {

            // Close the dropddown
            setIsOpen(false);

        }

    };



    // Attach outside click listener to close dropdown
    useEffect(() => {

        document.addEventListener('mousedown', handleOutsideClick);

        return () => document.removeEventListener('mousedown', handleOutsideClick);

    }, []);



    return (

        <div className={styles.wrapper} ref={wrapperRef}>

            <label className={styles.label}>{label}</label>

            <input
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onClick={handleInputClick}
                className={styles.input}
                //autoComplete="off"
            />

            {isOpen && (

                <ul className={styles.list}>

                    {[...options].sort((a, b) => a.localeCompare(b)).map((opt, idx) => (

                        <li
                            key={idx}
                            className={styles.item}
                            onClick={() => handleOptionClick(opt)}
                        >

                            {opt}

                        </li>

                    ))}

                </ul>

            )}

        </div>

    );
    
};

export default CustomDropdownInput;